import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";
import { getTrackingHeadersMap } from "./getTrackingHeaders";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const UpdateOverageExceptionLocationAPI = async (
  params: {
    osdNumber: number;
    exceptionLocation: string;
  },
) => {
  try {
    const url = `${getUrl(ApiType.UPDATE_EXCEPTION_LOCATION).replace(
      ":osdNumber",
      params.osdNumber.toString()
    )}`;
    const staticHeaders = getTrackingHeadersMap(ApiType.UPDATE_EXCEPTION_LOCATION);
    const headers = {
      ...staticHeaders,
      "OSD-Reporting-Terminal": getTerminalId(),
      "OSD-Exception-Number": params.osdNumber.toString(),
    };
    const response = await axios.put(url, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.updateExceptionLocationError);
  }
};
